module.exports = __webpack_public_path__ + "Bildschirmfoto.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Bildschirmfoto.png
// module id = 150
// module chunks = 0